export default function getCappedValue(
  value: number | undefined,
  minimum: number | undefined,
  maximum: number | undefined,
  increment: number | undefined,
): number | undefined {
  if (!Number.isInteger(value)) {
    return Number.isInteger(minimum) ? minimum : 0;
  }

  let v = value;
  if (v !== undefined) {
    if (
      increment !== undefined &&
      Number.isInteger(increment) &&
      increment !== 1
    ) {
      v =
        (minimum || 0) +
        Math.floor((v - (minimum || 0)) / increment) * increment;
    }

    if (minimum !== undefined && Number.isInteger(minimum) && v < minimum) {
      return minimum;
    }

    if (maximum !== undefined && Number.isInteger(maximum) && v > maximum) {
      return maximum;
    }
    return v;
  }
  return v;
}
